export default __webpack_public_path__ + "static/ccs-7f00f81568d9510408605705532a8fcb.png";